import { apiService } from "../../app.service";

export const supplierApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchSupplieres: builder.query({
      query: () => ({
        url: "/user/supplier/getAll",
      }),
      providesTags: ["suppliers"],
    }),

    createSupplier: builder.mutation({
      query: (data) => ({
        url: "/user/supplier/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["suppliers"],
    }),

    updateSupplier: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/supplier/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "supplier", id },
        "suppliers",
      ],
    }),

    deleteSupplier: builder.mutation({
      query: (id) => ({
        url: `/user/supplier/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["suppliers"],
    }),
  }),
});

export const {
  useFetchSupplieresQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = supplierApi;
